/**
 * Created by istvan.rozsa on 2017. 04. 28..
 */

export default function SendEmailFactory(COMMON_CONSTS, DOCUMENT_TYPE, $filter) {
	const FORM_TITLE_TRANSLATOR_KEYS = {
		SEND_INVOICE: 'send_invoice',
		PAYMENT_REMINDER: 'payment_reminder',
		PROFORMA: 'send_proforma'
	};
	const EMAIL_SUBJECT_TRANSLATOR_KEYS = {
		NEW_STORNO_INVOICE: 'stornoInvoice_default_subject',
		NEW_SALES_INVOICE: 'salesInvoice_default_subject',
		NEW_PROFORMA_INVOICE: 'proformaInvoice_default_subject',
		PAYMENT_REMINDER: 'paymentReminder_subject'
	};
	const EMAIL_BODY_TRANSLATOR_KEYS = {
		STORNO_INVOICE: 'stornoInvoice_default_body',
		SALES_INVOICE: 'salesInvoice_default_body',
		PROFORMA_INVOICE: 'proformaInvoice_default_body'
	};

	function setOptions(options, title, subjectIsRequired, messageIsRequired, isTagsInput, subject, body) {
		options.title = $filter('translator')(title);
		options.requiredModel.subjectIsRequired = subjectIsRequired;
		options.requiredModel.messageIsRequired = messageIsRequired;
		options.subject = subject ? $filter('translator')(subject) : '';
		options.isTagsInput = isTagsInput;
		options.body = body ? $filter('translator')(body) : '';
	}

	var setFormOptions = function (options, selectedDetailsTab, docName) {
		var messageIsRequired = true;
		var subjectIsRequired = true;
		var isTagsInput = true;

		switch (selectedDetailsTab) {
			case 'sendInvoice':
				setOptions(options, FORM_TITLE_TRANSLATOR_KEYS.SEND_INVOICE, subjectIsRequired, messageIsRequired,
					isTagsInput, EMAIL_SUBJECT_TRANSLATOR_KEYS.NEW_SALES_INVOICE, EMAIL_BODY_TRANSLATOR_KEYS.SALES_INVOICE);
				break;
			case 'proforma':
				setOptions(options, FORM_TITLE_TRANSLATOR_KEYS.PROFORMA, !subjectIsRequired, !messageIsRequired,
					isTagsInput, EMAIL_SUBJECT_TRANSLATOR_KEYS.NEW_PROFORMA_INVOICE, EMAIL_BODY_TRANSLATOR_KEYS.PROFORMA_INVOICE);
				break;
			case 'invoice':
			case 'bill':
				setOptions(options, FORM_TITLE_TRANSLATOR_KEYS.SEND_INVOICE, !subjectIsRequired, !messageIsRequired,
					isTagsInput, EMAIL_SUBJECT_TRANSLATOR_KEYS.NEW_SALES_INVOICE, EMAIL_BODY_TRANSLATOR_KEYS.SALES_INVOICE);
				break;
			case 'reminder':
			case 'paymentReminder':
				const BODY = docName == DOCUMENT_TYPE.PROFORMA_OUT ? EMAIL_BODY_TRANSLATOR_KEYS.PROFORMA_INVOICE : EMAIL_BODY_TRANSLATOR_KEYS.SALES_INVOICE;
				setOptions(options, FORM_TITLE_TRANSLATOR_KEYS.PAYMENT_REMINDER, subjectIsRequired, messageIsRequired,
					isTagsInput, EMAIL_SUBJECT_TRANSLATOR_KEYS.PAYMENT_REMINDER, BODY);
				break;
			case 'storno':
				setOptions(options, FORM_TITLE_TRANSLATOR_KEYS.SEND_INVOICE, subjectIsRequired, messageIsRequired,
					isTagsInput, EMAIL_SUBJECT_TRANSLATOR_KEYS.NEW_STORNO_INVOICE, EMAIL_BODY_TRANSLATOR_KEYS.STORNO_INVOICE);
				break;
			case 'copy':
				var title = docName == DOCUMENT_TYPE.PROFORMA_OUT ?
					FORM_TITLE_TRANSLATOR_KEYS.PROFORMA : FORM_TITLE_TRANSLATOR_KEYS.SEND_INVOICE;
				setOptions(options, title, subjectIsRequired, messageIsRequired, !isTagsInput);
				break;
			default:
				setOptions(options, FORM_TITLE_TRANSLATOR_KEYS.SEND_INVOICE, subjectIsRequired, messageIsRequired, isTagsInput);
		}
	};

	return {
		setFormOptions: setFormOptions
	};
}
